module.exports = __webpack_public_path__ + "img/loading-spin.7f0e2fa7.svg";